import { SearchContextState } from '@elastic/react-search-ui/lib/cjs/withSearch'
import { InfiniteData, QueryClient } from 'react-query'

const checkMatchParams = [
  'makes',
  'models',
  'part_number',
  'category_id',
  'sub_category_id',
  'generation_id'
]

export const canAddMatchMe = (values: MatchMeFV): boolean => {
  const { makes, models, category_id, sub_category_id } = values

  const matchParamsCount = [makes, models, category_id, sub_category_id].filter(
    (param) => !!param
  ).length

  return matchParamsCount === 4
}

export const selectMatchMe = (
  data: InfiniteData<MatchMePaginationModel> | undefined
) => {
  if (!data)
    return {
      match_me: [],
      pagy: {},
      pageParams: []
    }

  return {
    match_me: data?.pages?.flatMap((page) => page.match_me),
    pagy: data?.pages[0]?.pagy,
    pageParams: data?.pageParams
  }
}

interface GetLetsMatchedDefaultValuesProps {
  filters?: SearchContextState['filters']
  defaultFormValues: MatchMeFV
}

export const generateLetsMatchedFormValues = ({
  filters,
  defaultFormValues
}: GetLetsMatchedDefaultValuesProps) =>
  filters?.reduce((acc, filter) => {
    const { field, values } = filter
    const fieldNameWithoutKeyword = field.replace('.keyword', '')
    const value = values[0]

    if (checkMatchParams.includes(fieldNameWithoutKeyword)) {
      return { ...acc, [fieldNameWithoutKeyword]: value }
    }

    return acc
  }, defaultFormValues)

interface GetLetsMatchedModelIdProps {
  queryClient: QueryClient
  make?: string
  model?: string
}

export const getLetsMatchedModelId = async ({
  queryClient,
  make,
  model
}: GetLetsMatchedModelIdProps) => {
  await queryClient.refetchQueries({
    queryKey: ['options', make],
    active: true,
    exact: true
  })

  const cacheDataFromModels = queryClient.getQueryData<Model[]>(
    ['options', make],
    { exact: false }
  )

  const modelId = cacheDataFromModels?.find((item) => item.name === model)?.id

  return modelId
}
